// Web replacement for @react-native-documents/picker (native-only package).
// Wired up via the "browser" field in package.json; on native, metro.config.js
// resolves the real package instead. The web code path uses a browser file
// input instead (see DocumentsList.js), so these are never called on web.
export const pick = () => Promise.reject(new Error('Document picker is not available on web'));
export const errorCodes = {};
export const isErrorWithCode = () => false;
